export default "__VITE_ASSET__98DqaqIB__"